/*  ========================================================================
    # Hooks - Use Posts API
    ========================================================================  */

import { useEffect, useState } from 'react';

const usePostsApi = params => {
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [postsCount, setPostsCount] = useState(0);
  const [posts, setPosts] = useState([]);
  const paramsString = new URLSearchParams();

  const getPosts = async () => {
    setLoadingPosts(true);

    for (const [key, value] of Object.entries(params)) {
      if (key === 'categories') {
        if (value !== '') {
          paramsString.append(key, value);
        }
      } else {
        paramsString.append(key, value);
      }
    }

    try {
      const response = await fetch(`/wp-json/wp/v2/posts?${paramsString.toString()}`);

      if (response.status !== 200) {
        throw new Error(await response.text());
      }

      const posts = await response.json();
      const mappedPosts = posts.map(post => ({
        id: post.id,
        image: post.featured_image,
        title: post.title.rendered,
        date: post.date,
        author: post.acf?.displayed_author,
        excerpt: post.excerpt.rendered.replace('<p>', '').replace('</p>', ''),
        url: post.link
      }));

      setLoadingPosts(false);
      setPostsCount(parseInt(response.headers.get('X-WP-Total'), 10));
      setPosts(mappedPosts);
    } catch (error) {
      setLoadingPosts(false);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    getPosts();
  }, [params.per_page, params.page, params.categories, params.search]);

  return { loadingPosts, postsCount, posts };
};

export default usePostsApi;
